import {
	IconBackpack,
	IconSchool
} from '@tabler/icons-react';
import { useState } from 'react';

import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
	navbar: {
		height: "100%",
		width: 300,
		padding: theme.spacing.md,
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: theme.colors.blueFilled || theme.colors.blue[8],
	},

	navbarMain: {
		flex: 1,
	},
	navbarHeader: {
		color: theme.colors.blue[1],
		fontSize: 30,
		marginBottom: 25,
		alignSelf: "center"
	},

	header: {
		paddingBottom: theme.spacing.md,
		marginBottom: `calc(${theme.spacing.md} * 1.5)`,
		borderBottom: `1px solid ${theme.colors.blue[7]}`,
	},

	footer: {
		paddingTop: theme.spacing.md,
		marginTop: theme.spacing.md,
		borderTop: `1px solid ${theme.colors.blue[7]}`,
	},

	version: {
		backgroundColor: theme.colors.blue[7],
		color: theme.white,
	},

	link: {
		display: 'flex',
		alignItems: 'center',
		textDecoration: 'none',
		fontSize: theme.fontSizes.sm,
		color: theme.white,
		padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
		borderRadius: theme.radius.sm,
		fontWeight: 500,
		transition: 'background-color 150ms ease, color 150ms ease',

		'&:hover': {
			backgroundColor: theme.colors.blue[7],
			color: theme.white,

			[`& .${'linkIcon'}`]: {
				color: theme.white,
			},
		},

		'&[data-active]': {
			boxShadow: theme.shadows.sm,
			backgroundColor: theme.colors.blue[0],
			color: theme.colors.blueFilled || theme.colors.blue[6],

			[`& .${'linkIcon'}`]: {
				color: theme.colors.blueFilled || theme.colors.blue[6],
			},

			'&:hover': {
				backgroundColor: theme.white,
				color: theme.colors.blueFilled || theme.colors.blue[6],

				[`& .${'linkIcon'}`]: {
					color: theme.colors.blueFilled || theme.colors.blue[6],
				},
			},
		},
	},

	linkIcon: {
		color: theme.colors.blue[1],
		marginRight: theme.spacing.sm,
		width: 25,
		height: 25,
	},
}));

const data = [
	{ link: '', label: 'My Performances', icon: IconBackpack },
	{ link: '', label: 'My School', icon: IconSchool },
];

export function SocialSidebar() {
	const [active, setActive] = useState('My Performances');
	const { classes } = useStyles();

	const links = data.map((item) => (
		<a
			className={classes.link}
			data-active={item.label === active || undefined}
			href={item.link}
			key={item.label}
			onClick={(event) => {
				event.preventDefault();
				setActive(item.label);
			}}
		>
			<item.icon className={classes.linkIcon} stroke={1.5} />
			<span>{item.label}</span>
		</a>
	));

	return (
		<nav className={classes.navbar}>
			<div className={classes.navbarHeader}>My Videos</div>
			<div className={classes.navbarMain}>
				{links}
			</div>

			<div className={classes.footer}>
			</div>
		</nav>
	);
}